// src/features/home/homeSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/api';
export const fetchHome = createAsyncThunk('home/fetchHome', async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get('home', { signal }); return r.data.data; } catch (e) { return rejectWithValue(e?.response?.data || e.message); }
});

export const fetchWelcomeScreen = createAsyncThunk('home/fetchWelcomeScreen', async (_, { signal, rejectWithValue }) => {
  try { const r = await api.get('welcome_screen', { signal }); return r.data.data; } catch (e) { return rejectWithValue(e?.response?.data || e.message); }
});

const slice = createSlice({
  name: 'home', 
  initialState: { homeData: null, welcomeScreenData: null,userGuidData: null, status: 'idle', error: null },
  reducers: {
    setUserGuidData: (state, actions) => {
      state.userGuidData = actions.payload;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchHome.pending, (s) => { s.status = 'loading'; s.error = null; })
     .addCase(fetchHome.fulfilled, (s, a) => { s.status = 'succeeded'; s.homeData = a.payload; })
     .addCase(fetchHome.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload || a.error.message; })
     .addCase(fetchWelcomeScreen.pending, (s) => { s.welcomeScreenData = null; })
     .addCase(fetchWelcomeScreen.fulfilled, (s, a) => { s.welcomeScreenData = a.payload; })
     .addCase(fetchWelcomeScreen.rejected, (s) => { s.welcomeScreenData = null; });
  }
});
export const { setUserGuidData } = slice.actions;

export const homeState = (state) => state.home;
export default slice.reducer;
